var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('destination-form',{model:{value:(_vm.destination),callback:function ($$v) {_vm.destination=$$v},expression:"destination"}})}
var staticRenderFns = []

export { render, staticRenderFns }